import { type TableBlock } from 'cms-types'

function TableBlock({ tableHTML }: TableBlock) {
  return <div className='overflow-x-auto' dangerouslySetInnerHTML={{ __html: tableHTML }} />
}

export default TableBlock
